"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarterPlan = void 0;
const Plan_1 = require("../../Domain/Plan");
const features_1 = require("../../features");
const limits_1 = require("../../limits");
exports.StarterPlan = Plan_1.Plan.create(features_1.CademyFeatures, limits_1.CademyLimits, {
    id: '01J5ZYYDS1T7BG7CMYNGCWJ3CN',
    name: 'Starter',
    visible: false,
    pricing: {
        GBP: {
            monthly: 49,
            yearly: 468,
        },
        USD: {
            monthly: 59,
            yearly: 588,
        },
        EUR: {
            monthly: 59,
            yearly: 588,
        },
    },
    features: {
        general: {
            customCertificates: false,
            scorm: false,
            privateDates: true,
            noteAttachments: false,
            importCourses: false,
        },
        marketplace: {
            hideProfile: true,
            hideCourses: true,
        },
        analytics: {
            monthlyAnalyticsEmails: true,
        },
        branding: {
            addYourBranding: true,
            customBrandColour: false,
            whitelabelling: false,
            customEmailDomain: false,
        },
        payments: {
            invoiceCheckouts: false,
            manualPayments: false,
        },
        privacyAndSecurity: {
            restrictMinisite: false,
            sso: false,
            privateCourses: true,
        },
        apps: {
            zapier: false,
        },
        ai: {
            courseGeneration: true,
        },
        api: {
            apiKeys: false,
        },
    },
    limits: {
        numberOfAdmins: {
            period: null,
            value: 1,
            kind: 'hard',
        },
        numberOfCourseInvites: {
            kind: 'hard',
            period: null,
            value: 2000,
        },
        numberOfImportedBookings: {
            kind: 'hard',
            period: null,
            value: 1000,
        },
        numberOfImportedOrders: {
            kind: 'hard',
            period: null,
            value: 1000,
        },
        numberOfPublishedCourses: {
            kind: 'hard',
            period: null,
            value: 25,
        },
        maxFileUploadSize: {
            kind: 'hard',
            period: null,
            value: 1024,
        },
        maxAgeOfForumPosts: {
            kind: 'hard',
            period: null,
            value: 30,
        },
        aiCredits: {
            kind: 'hard',
            period: 'monthly',
            value: 100,
        },
    },
});
